import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { messages as messagesLayout } from 'constants/layout'
import { apiConfiguration, apiContacts } from 'helpers/decorators/api'
import { CONFIGURATION_KEYS, ROLES } from 'constants/enums'
import { renderRoutes } from 'react-router-config'
import { getActiveRole } from '../../../utils/token'

@apiConfiguration()
@apiContacts()
@connect(
  ({ api, auth }) => ({
    user: auth.user,
    activeOrganization: auth.organization,
    configuration: api.configuration,
    activeOrganizationContact: api.contacts.active
  }),
  { push }
)
class Messages extends Component {
  static propTypes = {
    children: PropTypes.any,
    push: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    configuration: PropTypes.object.isRequired,
    tabs: PropTypes.object,
    route: PropTypes.object,
    activeOrganizationContact: PropTypes.object,
    getActiveOrganizationContact: PropTypes.func,
    getConfigurationManageParticipants: PropTypes.func.isRequired,
    activeOrganization: PropTypes.object
  }

  state = {
    allowMessagesFilter: true
  }

  componentWillMount() {
    this.props.getActiveOrganizationContact()
    this.props.getConfigurationManageParticipants()
  }

  render() {
    const { tabs, children, configuration, route } = this.props

    const { allowMessagesFilter } = this.state

    const messagesTabs = messagesLayout.tabsList.map(item => {
      if (item.id === 2) {
        const authorized = (get(configuration.values[CONFIGURATION_KEYS.manageAllParticipants.id], 'booleanValue') ||
            get(this.props.activeOrganizationContact, 'isCoordinator')) && getActiveRole(this.props.activeOrganization) ===
            ROLES.LEADER.u
        return {
          ...item,
          authorized
        }
      }

      return {
        ...item
      }
    })

    const extraProps = {
      user: this.props.user,
      push: this.props.push,
      params: this.props.params,
      allowMessagesFilter
    }

    return (
      <div>
        {allowMessagesFilter &&
          tabs &&
          React.cloneElement(tabs, {
            links: messagesTabs,
            isRestricted: true
          })}
        {children
          ? React.cloneElement(children, extraProps)
          : renderRoutes(route.routes, extraProps)
        }
      </div>
    )
  }
}

export default Messages
